import { useEffect, useState } from "react";
import "./rateContractDocument.scss";

import { Box, Button, Input, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import { CreateNewFolder } from "@mui/icons-material";
import {
  PAGES_URL,
  UPLOAD_FILE_PURPOSE_TYPE,
} from "../../../../shared/constants/constants";
import store from "../../../../store/store";
import { uploadFile } from "../../../../store/api/fileUpload";
import Overlay from "../../../../components/loadingOverlay/overlay";
import ErrorPopup from "../../../../components/dialogBox/errorModal";
import SuccessDialog from "../../../../components/dialogBox/successDialog";

type ContractDocumentProps = {
  handleUploadedContractData: (data: any) => void;
};

const RateContractDocument = ({
  handleUploadedContractData,
}: ContractDocumentProps) => {
  const [fileData, setFileData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState({ open: false, message: "" });
  const [error, setError] = useState({ open: false, message: "" });
  const [uploaded, setUploaded] = useState(false);
  const [dots, setDots] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) {
      const interval = setInterval(() => {
        setDots((prev) => (prev.length < 3 ? prev + "." : ""));
      }, 500);
      return () => clearInterval(interval);
    }
  }, [isLoading]);

  const handleUploadFile = (file: any) => {
    if (!file) return;
    setFileData(file[0]);
    if (file[0] == null || file?.length <= 0) {
      return;
    }

    setIsLoading(true);
    const formData = new FormData();
    formData.append("file", file[0]);
    formData.append(
      "filePurposeType",
      UPLOAD_FILE_PURPOSE_TYPE.RATE_CONTRACT_FILE
    );
    formData.append("requestId", "");
    formData.append("channelName", "WEB");

    store
      .dispatch(uploadFile(formData))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          handleUploadedContractData(res?.data?.rateContract);
        } else {
          setError({ open: true, message: res?.error });
        }
      })
      .catch((error) => {
        setError({
          open: true,
          message:
            "File upload failed due to exceeding the allowed item limit. Please split the data into smaller files or fill details manually.",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleCloseSuccess = () => {
    setSuccess({ ...success, open: false });
    navigate(PAGES_URL?.DASHBOARD);
  };

  const handleCloseError = () => {
    setError({ ...error, open: false });
  };

  return (
    <>
      {isLoading && <Overlay spinnerMessage={"Processing File"} />}
      <Box
        sx={{
          px: 6,
        }}
      >
        {/* <Box sx={{
                backgroundColor: 'white',
                boxShadow: 3,
                p: {
                    xs: 2,
                    sm: 4,
                },
                minHeight: '20vh',
                mb: 4,
            }}> */}
        <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
          Upload Rate Contract
        </Typography>
        <Typography
          variant="body2"
          style={{ fontStyle: "italic", marginTop: "4px" }}
        >
          Upload a rate contract file to auto-populate prices using OCR, instead
          of entering them manually.
        </Typography>
        <Box
          className="file-input-box"
          sx={{
            width: 1,
            borderRadius: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#f6f6f6",
            p: {
              xs: 1,
              sm: 1,
            },
            mt: 1,
            position: "relative",
            cursor: "pointer",
            border: "1px dashed #E6E6E6",
          }}
        >
          {fileData && fileData?.name ? (
            <Typography
              variant="subtitle1"
              sx={{
                color: "black",
                fontWeight: "medium",
                cursor: "pointer",
              }}
            >
              {fileData?.name}
            </Typography>
          ) : (
            <Typography
              variant="subtitle1"
              sx={{
                color: "#909090",
                fontWeight: "medium",
                cursor: "pointer",
              }}
            >
              Choose file
            </Typography>
          )}
          <Button
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#22438C",
              backgroundColor: "#ddf2ff",
              borderRadius: 0,
              textTransform: "none",
              cursor: "pointer",
              px: 2,
              py: 1,
            }}
          >
            Upload file <CreateNewFolder fontSize="small" />
          </Button>
          <Input
            type="file"
            inputProps={{
              accept:
                ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf, image/jpeg, image/png, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, .doc, .docx",
            }}
            onChange={(event) => {
              if (event?.target instanceof HTMLInputElement) {
                handleUploadFile(event?.target?.files);
              }
            }}
            sx={{
              width: 1,
              height: 1,
              opacity: 0,
              border: "none",
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              cursor: "pointer",
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xs: "column",
              sm: "row",
            },
            gap: {
              xs: 1,
              sm: 2,
            },
            my: 2,
          }}
        ></Box>
        {/* </Box> */}
        <ErrorPopup
          open={error.open}
          message={error.message}
          onClose={handleCloseError}
        />
        <SuccessDialog
          open={success.open}
          message={success.message}
          onClose={handleCloseSuccess}
        />
      </Box>
    </>
  );
};

export default RateContractDocument;
